export default {
    methods: {
        /**
         * Adds a video to the shopping cart without mutating the gallery item.
         *
         * @param {Object} videoSelected Selected video.
         * @param {string} albumUuidSelected Parent album UUID.
         * @param {Array<Object>} videosRelated Related videos.
         * @param {Object} album Album experience.
         * @returns {Promise<Object|null>} Quoted cart item or null.
         */
        async AddVideoToShoppingCart(
            videoSelected,
            albumUuidSelected,
            videosRelated,
            album
        ) {
            const product = {
                ...videoSelected,
                AlbumUuid: albumUuidSelected,
                VideosRelated: Array.isArray(videosRelated)
                    ? videosRelated.map((video) => ({ ...video }))
                    : [],
                Album: album,
            };

            return this.$store.dispatch("addCartByVideo", product);
        },
    },
};
